import { useCallback } from 'react';

interface PostMessage {
  iframeId: string;
  message?: any;
  origin?: string;
}
const useIframe = () => {
  const postMessage = useCallback(
    ({ iframeId, message, origin = '*' }: PostMessage) => {
      const iframeEl = document.getElementById(iframeId) as HTMLIFrameElement;
      if (!iframeEl) return;

      iframeEl.contentWindow?.postMessage(message, origin);
    },
    []
  );

  return { postMessage };
};

export default useIframe;
